import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import question from './modules/question'
import course from './modules/course'
import knowledge from './modules/knowledge'
import answer from './modules/answer'
import ua from './modules/ua'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

// const checkWebp = function () {
//   try {
//     return (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0)
//   } catch (err) {
//     return false
//   }
// }
// const isWebP = checkWebp()

const rootState = {
  website: {
    website_name_shortcut: 'Comet Academy'
  },
  // isWebP,
  ua
}

const rootGetters = {
  isWebP () {
    return rootState.isWebP
  }
}

const rootMutations = {

}

const rootActions = {
  changeDomTitle ({ commit, state }, payload) {
    if (payload && payload.title) {
      window.document.title = payload.title
    } else {
      window.document.title = state.route.meta.title
    }
  }
}

export default new Vuex.Store({
  modules: {
    user,
    question,
    course,
    knowledge,
    answer
  },
  state: rootState,
  getters: rootGetters,
  mutations: rootMutations,
  actions: rootActions,
  strict: debug
})
